import { RestaurantList } from "./RestaurantList";
import RestaurantCreate from "./RestaurantCreate";
import RestaurantEdit from "./RestaurantEdit";
import RestaurantShow from "./RestaurantShow";
import RestaurantIcon from "@mui/icons-material/Restaurant";

// Every view is exported unconditionally. Who reaches what — including that only an
// admin creates a restaurant — is decided in utils/AccessControl.js.
const restaurants = {
  list: RestaurantList,
  create: RestaurantCreate,
  edit: RestaurantEdit,
  show: RestaurantShow,
  icon: RestaurantIcon,
};

export default restaurants;
